import { render, staticRenderFns } from "./PartnerList.vue?vue&type=template&id=107fbbe4&scoped=true"
import script from "./PartnerList.vue?vue&type=script&lang=js"
export * from "./PartnerList.vue?vue&type=script&lang=js"
import style0 from "./PartnerList.vue?vue&type=style&index=0&id=107fbbe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107fbbe4",
  null
  
)

export default component.exports